// @flow
import { makeStyles } from "@material-ui/core/styles";
export default makeStyles(() => ({
  root: {
    flexBasis: "80%",
    position: "relative"
  },
  invisible: { display: "none" },
  video: {
    width: "100%",
    height: "100%"
  }
}), { index: 1 })